import { PaneHeader } from '@/components/settings/pane-header';
import { WorkRolesEditor } from '@/components/settings/work-roles-editor';
import { ScrollArea } from '@/components/ui/scroll-area';

// Hosts the work-role vocabulary editor: the roster rail's filter pills and the options the
// employee editor offers. Shared org-wide; editing needs scheduling:manage.
export function WorkRolesSubPage({ canEdit }) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PaneHeader
        title="Work roles"
        description="Group support staff in the Work Plan roster (Nurse, Front desk, …). Shared with your whole team."
      />
      <ScrollArea className="min-h-0 flex-1" viewportClassName="p-6">
        <div className="mx-auto max-w-3xl">
          <WorkRolesEditor canEdit={canEdit} />
        </div>
      </ScrollArea>
    </div>
  );
}
